import React from "react";
import { Space, Typography } from "antd";
import CurrencyElement from "@appComponents/CurrencyElement/CurrencyElement";
import ArrowUp from "./arrow-up.svg";
import moment from "moment";
import { StakingReward } from "./RewardsTable";

export const rewardsColumns = [
  {
    title: "DATE",
    dataIndex: "created_at",
    key: "date",
    width: "20%",
    sorter: (a: StakingReward, b: StakingReward) =>
      moment(a.created_at).unix() - moment(b.created_at).unix(),
    render: (text: string) => moment(text).format("DD.MM.YYYY"),
  },
  {
    title: "TYPE",
    dataIndex: "type",
    key: "type",
    sorter: true,
    width: "15%",
    align: "center" as const,
  },
  {
    title: "CHANGE",
    dataIndex: "amount",
    key: "change",
    width: "30%",
    align: "center" as const,
    sorter: (a: StakingReward, b: StakingReward) =>{
      return a.amount_usd - b.amount_usd
    },
    render: (text: string, row: StakingReward) => (
      <>  
        <Space style={{justifyContent: 'center'}}>
          <ArrowUp />
          <Typography.Text style={{ color: "#2D9C5E" }}>
            <CurrencyElement value={text} currency={"eth"} />
          </Typography.Text>
        </Space>
        <br />
        <Typography.Text style={{ paddingLeft: "25px" }}>
          <CurrencyElement value={row.amount_usd} currency={"usd"} />
        </Typography.Text>
      </>
    ),
  },
  {
    title: "BALANCE",
    dataIndex: "balance",
    key: "balance",
    width: "35%",
    sorter: (a: StakingReward, b: StakingReward) =>{
      return a.balance_usd - b.balance_usd
    },
      
    align: "right" as const,
    render: (text: string, row: StakingReward) => (
      <div>
        <Typography.Text strong>
          <CurrencyElement value={text} currency={"eth"} />
        </Typography.Text>
        <br />
        <Typography.Text>
          <CurrencyElement value={row.balance_usd} currency={"usd"} />
        </Typography.Text>
      </div>
    ),
  },
];

export default rewardsColumns;
